import { useQuery } from "@tanstack/react-query";
import api from "../../../api/api";
import { QUERY_EXTERNAL_ACCOUNTS } from "../../../api/queryKeys";
import { QueryExternalAccountResponse } from "../../../types";

export const getExternalAccounts = () =>
  api
    .get<QueryExternalAccountResponse>(QUERY_EXTERNAL_ACCOUNTS)
    .then((res) => res.data);

export default function useGetExternalAccounts() {
  return useQuery([QUERY_EXTERNAL_ACCOUNTS], getExternalAccounts);
}
